// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"f1d15220","348":"e1722fcb"}[chunkId] + ".chunk.css";
};